export const getEntryContentTxt = ({
  time,
  shouldDisplayDuration,
  duration
}: {
  time: string;
  shouldDisplayDuration: boolean;
  duration?: string;
}) => `${time} ${shouldDisplayDuration ? `• ${duration}` : ''}`;
